/* Latency Toggle — settings panel row */

.row {
  display: flex;
  align-items: flex-start;
  gap: var(--spacing\/1, 8px);
  padding: var(--spacing\/1, 8px) var(--spacing\/2, 16px);
  cursor: pointer;
}

.row:hover {
  background-color: rgba(49, 75, 153, 0.5);
}

.row:focus-visible {
  outline: 2px solid var(--color\/text\/link-default, #75adfc);
  outline-offset: -2px;
}

.icon {
  flex-shrink: 0;
  width: 24px;
  height: 24px;
  display: flex;
  align-items: center;
  justify-content: center;
  color: var(--color\/text\/text-primary, #fff);
}

.icon svg {
  width: 24px;
  height: 24px;
  fill: currentColor;
}

.label {
  display: flex;
  flex-direction: column;
  justify-content: center;
  flex: 1 0 0;
  min-width: 1px;
  font-family: 'Open Sans', sans-serif;
  font-size: var(--font\/fontsize\/body-small, 14px);
  font-weight: var(--typography\/weight\/regular, 400);
  line-height: 0;
  color: var(--color\/text\/text-primary, #fff);
  opacity: 0.75;
  overflow: hidden;
}

.labelText {
  display: block;
  line-height: 1.7;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  margin: 0;
}

.disabled {
  opacity: 0.5;
  pointer-events: none;
  cursor: default;
}
